import {
    facadeGalleryFilters,
    updateFilters,
} from '../components/FacadeGalleryFilter';
import LightBox from '../components/LightBox';
import QuickViewModal from '../components/QuickViewModal';

const photosFacadePanel = document.getElementById('js-photo-facade-filters') as HTMLElement;
const photosExtColorPanel = document.getElementById('js-photo-extcolor-filters') as HTMLElement;

const facadeButtons = photosFacadePanel.querySelectorAll<HTMLButtonElement>(
    '.js-btn-filter[data-filtertype="facade"]',
);

const extColorButtons = photosExtColorPanel.querySelectorAll<HTMLButtonElement>(
    '.js-btn-filter[data-filtertype="extcolor"]',
);

const facadeAllButton = photosFacadePanel.querySelector<HTMLButtonElement>('.js-btn-filter[data-filtertype="facade"][data-filter="all"]');
const extColorAllButton = photosFacadePanel.querySelector<HTMLButtonElement>('.js-btn-filter[data-filtertype="extcolor"][data-filter="all"]');

document.addEventListener('DOMContentLoaded', () => {
    LightBox();

    //quick view init
    const quickviewModal = QuickViewModal('js-quickview-modal');



    document.querySelectorAll('.js-btn-filter').forEach(button => {
        button.addEventListener('click', event => {
            const target = event.currentTarget as HTMLElement;
            const filterType = target.dataset.filtertype; // Get the filter type from the button
            const filterValue = target.dataset.filter; // Get the value from the button

            if (!target) {
                return;
            }

            if (!filterType || !filterValue) {
                return; // Exit if the filter type or value is not defined
            }

            const parentContainer = target.parentElement;

            if (!parentContainer) {
                return;
            }

            // Update the corresponding filter value
            switch (filterType) {
                case 'plan':
                    facadeGalleryFilters.planValue = filterValue;
                    const seriesId = target.dataset.id;

                    if (filterValue === 'all') {
                        if (photosFacadePanel) {
                            facadeButtons.forEach(button => {
                                button.removeAttribute('disabled'); // Enable all interior color buttons
                                button.classList.remove('active'); // Remove active class

                                if (button.dataset.filter === 'all') {
                                    button.classList.add('active');
                                }

                            });
                        }

                        if (photosExtColorPanel) {
                            extColorButtons.forEach(button => {
                                button.removeAttribute('disabled'); // Enable all exterior color buttons
                                button.classList.remove('active'); // Remove active class

                                if (button.dataset.filter === 'all') {
                                    button.classList.add('active');
                                }
                            });
                        }
                    } else {
                        // Fetch data from API if plan is selected and value is not "all"
                        fetch(`/api/gallery/series-rooms/${seriesId}`)
                            .then(response => response.json())
                            .then((data: string[]) => {

                                if (photosFacadePanel) {
                                    facadeButtons.forEach(button => {
                                        const buttonValue = button.getAttribute('data-filter');
                                        // Disable buttons if their value is not in the returned data
                                        if (buttonValue && buttonValue !== 'all') {
                                            if (!data.includes(buttonValue)) {
                                                button.setAttribute('disabled', 'true');
                                            } else {
                                                button.removeAttribute('disabled');
                                            }
                                        } else if (buttonValue === 'all') {
                                            // Ensure the "All" button is always enabled
                                            button.removeAttribute('disabled');
                                        }
                                    });
                                }

                                if (photosExtColorPanel) {
                                    extColorButtons.forEach(button => {
                                        const buttonValue = button.getAttribute('data-filter');
                                        // Disable buttons if their value is not in the returned data
                                        if (buttonValue && buttonValue !== 'all') {
                                            if (!data.includes(buttonValue)) {
                                                button.setAttribute('disabled', 'true');
                                            } else {
                                                button.removeAttribute('disabled');
                                            }
                                        } else if (buttonValue === 'all') {
                                            // Ensure the "All" button is always enabled
                                            button.removeAttribute('disabled');
                                        }
                                    });
                                }


                            })
                            .catch(error => console.error('Error fetching room data:', error));
                    }

                    break;
                case 'facade':
                    facadeGalleryFilters.facadeValue = filterValue;
                    facadeGalleryFilters.extColorValue = 'all';
                    extColorButtons.forEach(button => {
                        button.classList.remove('active');
                    });
                    extColorAllButton?.classList.add('active');
                    break;
                case 'extcolor':
                    facadeGalleryFilters.extColorValue = filterValue;
                    facadeGalleryFilters.facadeValue = 'all';
                    facadeButtons.forEach(button => {
                        button.classList.remove('active');
                    });
                    facadeAllButton?.classList.add('active');
                    break;
                default:
                    console.warn(`Unknown filter type: ${filterType}`);
                    return; // Exit if the filter type is unknown
            }

            // Call the update function to refresh the displayed images
            updateFilters();

            // Remove active class from all buttons of the same type and add to the clicked one
            parentContainer
                .querySelectorAll(`button[data-filtertype="${filterType}"]`)
                .forEach(btn => {
                    btn.classList.remove('active'); // Remove active class from all buttons of the same type
                });
            target.classList.add('active'); // Add active class to the clicked button
        });
    });
});
